import Vue from 'vue';
// eslint-disable-next-line import/no-cycle
import feathersClient from '../../feathers-client';

const defaultSyncOnboardUserHistoryPagination = {
	total: 100,
	$skip: 0,
	$limit: 10,
};
const defaultSyncOnboardUserHistoryFilter = {
	$skip: defaultSyncOnboardUserHistoryPagination.$skip,
	$limit: defaultSyncOnboardUserHistoryPagination.$limit,
};
export default {
	state: {
		syncOnboardUserHistory: [],
		syncOnboardUserHistoryPagination: defaultSyncOnboardUserHistoryPagination,
		SyncOnboardUserHistoryFilter: defaultSyncOnboardUserHistoryFilter,
	},
	getters: {
		setsyncOnboardUserHistoryPage: (state) => {
			const { $limit, $skip } = state.syncOnboardUserHistoryPagination;
			return $skip / $limit + 1;
		},
	},
	mutations: {
		SET_SYNC_ONBOARD_USER_HISTORY: (state, data) => { state.syncOnboardUserHistory = data; },
		SET_SYNC_ONBOARD_USER_HISTORY_PAGINATION: (state, data) => { state.syncOnboardUserHistoryPagination = {...state.syncOnboardUserHistoryPagination, ...data};},
		SET_SYNC_ONBOARD_USER_HISTORY_FILTER: (state, filter) => { state.SyncOnboardUserHistoryFilter = { ...state.SyncOnboardUserHistoryFilter, ...filter }; },
		SET_SYNC_ONBOARD_USER_HISTORY_PERMISSION: (state, syncOnboardUserHistoryPermission) => { state.syncOnboardUserHistoryPermission = syncOnboardUserHistoryPermission; },
	},
	actions: {
		setSyncOnboardUserHistoryFilter: ({ commit }, filter) => {
			commit('SET_SYNC_ONBOARD_USER_HISTORY_FILTER', filter);
		},
		setsyncOnboardUserHistoryListPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.syncOnboardUserHistoryPagination.$limit;
			commit('SET_SYNC_ONBOARD_USER_HISTORY_PAGINATION', { $skip });
			commit('SET_SYNC_ONBOARD_USER_HISTORY_FILTER', { $skip });
		},
		getAllSyncOnboardUserHistoryForTrust: async({ rootGetters, commit }, filter) => {
			const results = await feathersClient.service('api/v3/onboarded-optima-users-history').find({
				query: {
					// $role: rootGetters.currentUserRole,
					$sort: { createdAt: -1 },
					...filter,

				},
			});
			commit('SET_SYNC_ONBOARD_USER_HISTORY', results.data);
			commit('SET_SYNC_ONBOARD_USER_HISTORY_PAGINATION', { total: results.total });
			return results.data;
		},
		updateSyncOnboardUserHistoryForTrust: async({ rootGetters, commit }, data) => {
			const results = await feathersClient.service('/api/v3/onboarded-optima-users-history').patch(data.id, data, {
				// query:{
				// 	$role: rootGetters.currentUserRole,
				// }
			});
			return results;
		},
	},
};
